import {
  IAdditionEntity,
  IDropdownItem,
  IPricingDto,
  ISelectListItem,
} from "../../models";

export const groupAdditionEntitiesByPrice = (
  items: IAdditionEntity[],
): Record<number, IAdditionEntity[]> => {
  const groupedEntities = items?.reduce?.(
    (acc, entity) => {
      const key = entity.price;

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(entity);
      return acc;
    },
    {} as Record<number, IAdditionEntity[]>,
  );
  return groupedEntities;
};

export const mapPricesToAdditions = (
  prices: IPricingDto[],
  areas: IDropdownItem[],
): IAdditionEntity[] => {
  const result = prices.map((price: IPricingDto) => {
    return price.areaIds?.map((areaId: number) => ({
      id: areaId,
      price: price.price,
      name: getAdditionEntityName(areaId, areas),
    }));
  });
  const mappedAdditions = result?.reduce((prev, next) => {
    return prev.concat(next);
  }, [] as IAdditionEntity[]);
  return mappedAdditions;
};

export const getAdditionEntityName = (
  id: number,
  entities: ISelectListItem[],
): string => {
  return entities?.find(entity => entity.value === id)?.label || "";
};

export const mapEntityPricesToDto = (
  prices: IAdditionEntity[],
): IPricingDto[] => {
  return prices.reduce((acc, area, i) => {
    const existing = acc?.find(item => item.price === area.price);

    if (existing) {
      existing.areaIds.push(area.id);
    } else {
      acc.push({ areaIds: [area.id], price: area.price });
    }

    return acc;
  }, [] as IPricingDto[]);
};
